import React, { Component } from 'react'
import './App.css'
import { randomSort } from './utils'
import Card from './Card'

const prizes = {
  'month': 5,
  'sneakers': 5,
  'charger': 15,
  'goodies': 27,
}

// TODO give reset instructions to Simon

class App extends Component {
  constructor(props) {
    super(props);
    const game = JSON.parse(localStorage.getItem('game'))

    // If we do not currently have a game state, create one now
    // TODO make game options configurable
    if (game === null) {
      const newGame = []
      Object.keys(prizes).forEach((prize) => {
        const count = prizes[prize]
        for (let i = 0; i < count; i++) {
          newGame.push({type: prize, picked: false})
        }
      })
      
      this.state = {game : newGame.sort(randomSort), types: Object.keys(prizes), picking: false}
    } else {
      // TODO shuffle on every page load?
      this.state = {game : game, types: Object.keys(prizes), picking: false};
    }

    this.pickCard = this.pickCard.bind(this)
    this.clearPicking = this.clearPicking.bind(this)
    this.resetGame = this.resetGame.bind(this)
  }

  pickCard(e) {
    const index = e.target.getAttribute('data-index')
    const types = this.state.types

    this.setState({type: types[Math.floor(Math.random() * types.length)], picking: true})

    const totalCycles = 4
    let count = 0

    // Cycle 5 times
    const interval = setInterval(() => {
      // If we are done cycling, set reward so it displays
      if (totalCycles <= count) {
        clearInterval(interval)
        const game = this.state.game
        this.setState({type: game[index]['type'], picking: true})

        setTimeout(() => {
          game[index]['picked'] = true
          this.setState({type: game[index]['type'], picking: true})
          localStorage.setItem('game', JSON.stringify(game))
        }, 1000)
        
      } else {
        // If not pick a random reward to show
        this.setState({type: types[Math.floor(Math.random() * types.length)], picking: true})
      }

      count++

    }, 1100)
  }

  resetGame() {
    var confirm = window.confirm('Are you sure you wish to reset the game?');
    if (confirm === true) {
      localStorage.removeItem('game')
      window.location.reload(true)
    }
  }

  clearPicking() {
    this.setState({picking: false})
  }

  render() {
    const state = this.state
    
    return (
      <div className='App'>
        <header className='App__header' onClick={this.resetGame}>
          <div className='App__header-logo' />
          <div className='App__header-title' />
          <div className='App__header-logo' />
        </header>
        
        <div className='App__content'>
          {state.game.map((card, index) => (<Card index={index} key={index} {...card} onClick={this.pickCard} />))}
        </div>
        
        {state.picking && 
          <div className='App__overlay' onClick={this.clearPicking}>
            <div className='App__selection flip-vertical-left'>
              <div className='front face' />
              <div className={'back face card_' + state.type} />
            </div>
          </div>}
        
        <div className='App__footer'>
          <div className='App__copyright'>Copyright &copy; 2019 Gazelle.AI</div>
        </div>
        
      </div>
    );
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App.js